import { render, staticRenderFns } from "./ExcelUpload.vue?vue&type=template&id=020d2962&scoped=true"
import script from "./ExcelUpload.vue?vue&type=script&lang=js"
export * from "./ExcelUpload.vue?vue&type=script&lang=js"
import style0 from "./ExcelUpload.vue?vue&type=style&index=0&id=020d2962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d2962",
  null
  
)

export default component.exports